import { BOT_ACCOUNT_ID } from "@/game-eft/constants/constants.mjs";

export default function isBotAccount(accountId: string): boolean {
  return accountId === BOT_ACCOUNT_ID;
}
